import { Card, Skeleton } from '@mui/material';

export const PackageCardSkeleton = () => {
  return (
    <Card
      className="blur"
      sx={{ p: 3, display: 'flex', alignItems: 'center', flexDirection: 'column', aspectRatio: '3 / 2' }}
    >
      <Skeleton variant="rounded" width="100%" height="100%" sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width="100%" sx={{ minHeight: 34 }} />
    </Card>
  );
};
